import { IAddUpdateEstoqueMedicamentoRequest } from "../../../../model/admin-portal/request/add-update-estoque-medicamento-request";
import { IEstoqueMedicamentoResponse } from "../../../../model/admin-portal/response/estoque-medicamento-response";
import { IOrgaoResponse } from "../../../../model/admin-portal/response/orgao-response";
import { ITermPaggedRequest } from "../../../../model/admin-portal/request/term-pagged-request";
import { PaginationResponse } from "../../../../model/base/response/pagination-response";

export type EstoquesMedicamentoState = {
    dataPaginatedListResponse: PaginationResponse<IEstoqueMedicamentoResponse>;
    isLoadingData: boolean;
    dataResponse: IEstoqueMedicamentoResponse | null;
    dataRequest: IAddUpdateEstoqueMedicamentoRequest;
    showAddEdit: boolean;
    dataSearchRequest: ITermPaggedRequest;
    orgaosList: IOrgaoResponse[];
};

export const initialDataRequest: IAddUpdateEstoqueMedicamentoRequest = {
    id: null,
    idOrgao: null,
    nomeMedicamento: '',
    quantidadeEstoque: null,
    dtaAtualizacao: ''
};

export const initialState: EstoquesMedicamentoState = {
    dataPaginatedListResponse: new PaginationResponse<IEstoqueMedicamentoResponse>(),
    isLoadingData: false,
    dataResponse: null,
    dataRequest: initialDataRequest,
    showAddEdit: false,
    dataSearchRequest: { page: 0, pageSize: 10, term: '' },
    orgaosList: []
};

export enum ACTION_TYPES {
    setDataPaginatedListResponse = 'setDataPaginatedListResponse',
    setIsLoadingData = 'setIsLoadingData',
    setDataResponse = 'setDataResponse',
    setDataRequest = 'setDataRequest',
    setShowAddEdit = 'setShowAddEdit',
    setDataSearchRequest = 'setDataSearchRequest',
    setOrgaosList = 'setOrgaosList'
}

type Action =
    | { type: ACTION_TYPES.setDataPaginatedListResponse; payload: PaginationResponse<IEstoqueMedicamentoResponse> }
    | { type: ACTION_TYPES.setIsLoadingData; payload: boolean }
    | { type: ACTION_TYPES.setDataResponse; payload: IEstoqueMedicamentoResponse | null }
    | { type: ACTION_TYPES.setDataRequest; payload: IAddUpdateEstoqueMedicamentoRequest }
    | { type: ACTION_TYPES.setShowAddEdit; payload: boolean }
    | { type: ACTION_TYPES.setDataSearchRequest; payload: ITermPaggedRequest }
    | { type: ACTION_TYPES.setOrgaosList; payload: IOrgaoResponse[] };

export const estoquesMedicamentoReducer = (state: EstoquesMedicamentoState, action: Action): EstoquesMedicamentoState => {
    switch (action.type) {
        case ACTION_TYPES.setDataPaginatedListResponse:
            return { ...state, dataPaginatedListResponse: action.payload };
        case ACTION_TYPES.setIsLoadingData:
            return { ...state, isLoadingData: action.payload };
        case ACTION_TYPES.setDataResponse:
            return { ...state, dataResponse: action.payload };
        case ACTION_TYPES.setDataRequest:
            return { ...state, dataRequest: action.payload };
        case ACTION_TYPES.setShowAddEdit:
            return { ...state, showAddEdit: action.payload };
        case ACTION_TYPES.setDataSearchRequest:
            return { ...state, dataSearchRequest: action.payload };
        case ACTION_TYPES.setOrgaosList:
            return { ...state, orgaosList: action.payload };
        default:
            return state;
    }
};
